
import { IDataDefinition } from './idata-definition';
import { ICloneData } from './isharedata';


export class ObjectIDataDefinitionParserService {

  readonly stringType= 'string';
  readonly doubleType= 'double';
  readonly integerType= 'integer';
  readonly booleanType= 'boolean';
  readonly dateType= 'date';
  readonly selectType= 'select';
  readonly propertySetType= 'propertySet';
  readonly arrayType= 'array';




  
  public getEntityIDataDefinition(entityData: any)  : Array<IDataDefinition>{
    let self = this;
    let dataDefinitionArray = [];
    //
    //self.addIfValid(dataDefinitionArray, 'groups', entityData.groups, ['hsbmodel']);
    //self.addIfValid(dataDefinitionArray, 'coordSys', entityData.coordSys);

    Object.keys(entityData).forEach(key => {
      if(key !== 'groups' && key !== 'coordSys'){
        self.addIfValid(dataDefinitionArray, key, entityData[key]);
      }
    });

    return dataDefinitionArray;
  }
  private addIfValid(dataDefArray: Array<IDataDefinition>, propertyName: string, value: any, propertyNamesToIgnore: Array<string> | null = null){
    let typeDef = this.getIDataDefinitionFromValue(propertyName, value);
    if(!typeDef){return;}
    if(this.IsSimpleType(value)){

      dataDefArray.push(typeDef);
      return;
    }
    if(this.isObject(value)){
      let typeDefObj = this.getIDataDefinition(value, propertyNamesToIgnore);
      if(!typeDefObj){return;}
      typeDef.propertySet = typeDefObj;
      dataDefArray.push(typeDef);
    } else if(this.isArray(value)){
      let typeDefObj:any = this.getArrayIDataDefinition(value, propertyNamesToIgnore);
      if(!typeDefObj){return;}
      typeDef.subType = typeDefObj.subType;
      typeDef.propertySet = typeDefObj.propertySet;
      dataDefArray.push(typeDef);
    }
  }
  private IsSimpleType(value){
    return !this.isObject(value) && !this.isArray(value);
  }
  private getIDataDefinitionFromValue(propertyName: string, value: any): IDataDefinition | void{
    let typeInfo = this.getDataDefinitionType(value);
    if(!typeInfo){return;}
    let typeDef = this.getTypeDefinition(propertyName, typeInfo);
    return typeDef;
  }
  private getArrayTypeDef(subType) : IDataDefinition{
    return {
      type: 'array',
      subType: subType,
      readOnly: true,
      columnDef: '',
      header: '',
      class: null
    }
  }
  public getArrayIDataDefinition(anObject: any, propertyNamesToIgnore: Array<string>| null = null) : IDataDefinition | null {
    if(this.isArray(anObject)){
      if(anObject.length == 0){return null;}
      let subtype = this.getDataDefinitionType(anObject[0]);
      let typeDef: IDataDefinition = this.getArrayTypeDef(subtype);
      if(this.IsSimpleType(anObject[0])){
        return typeDef;
      }
      let propertySetArray =  this.getIDataDefinition(anObject[0], propertyNamesToIgnore);
      typeDef.propertySet = propertySetArray;
      return typeDef;
    }
    return null;
  }
  public getIDataDefinition(anObject: any, propertyNamesToIgnore: Array<string> | null = null) : Array<IDataDefinition> {
    if(this.isObject(anObject)){
      let propertyArray = this.listAllProperties(anObject, propertyNamesToIgnore);
      let dataDefinitionArray = this.listAllDataDefinitionProperties(anObject, propertyArray, propertyNamesToIgnore);
      return dataDefinitionArray;
    } else if(this.isArray(anObject)){
      if(anObject.length == 0){return [];}
      let subtype = this.getDataDefinitionType(anObject[0]);
      let typeDef: IDataDefinition = this.getArrayTypeDef(subtype);
      if(this.IsSimpleType(anObject[0])){
        return [typeDef];
      }
      let propertySetArray =  this.getIDataDefinition(anObject[0], propertyNamesToIgnore);
      typeDef.propertySet = propertySetArray;
    }
    return [];
  }
  private listAllProperties(anObject: any, propertyNamesToIgnore: Array<string> | null = null): Array<string> {   
    var result:any[] = [];

    result = result.concat(Object.getOwnPropertyNames(anObject));
    if(propertyNamesToIgnore){
      result = result.filter(property => propertyNamesToIgnore.indexOf(property) === -1); 
    }
    //propertyNamesToIgnore
    return result;
  }
  private listAllDataDefinitionProperties(anObject: any, propertyArray: Array<string>, propertyNamesToIgnore: Array<string> | null = null):  Array<IDataDefinition> {
    let dataDefinitionArray: Array<IDataDefinition> = []

    propertyArray.forEach( propName => {
      let dataDefEntry = this.getDataDefinitionEntry(anObject[propName], anObject, propName, propertyNamesToIgnore);
      if(dataDefEntry){
        dataDefinitionArray.push(dataDefEntry);
      }
    });
    
    return dataDefinitionArray; 
  }
  private getDataDefinitionEntry(value:any, anObject, propName, propertyNamesToIgnore: Array<string>|null = null): any{
    if(this.isString(value)){
      return this.getTypeDefinition(propName, this.getDataDefinitionType(value));
    }else if(this.isNumber(value)){
      return this.getTypeDefinition(propName, this.getDataDefinitionType(value));
    }else if(this.isArray(value)){
      if(value.length === 0){return null;}//empty array ignore
      let typeDef = this.getTypeDefinition(propName, this.getDataDefinitionType(value));
      let subType = this.getDataDefinitionType(value[0]);
      if(!subType){return null;}//unkown subtype
      typeDef['subType'] = subType;
      if(subType === this.propertySetType){
        let arrayPropertySet = [];
        if ((value[0] as ICloneData<any>).clone) {
          typeDef.class = value[0].clone();
        }

        let objectDataDef = this.getIDataDefinition(value[0]);

        // value.forEach(objectItem => {
        //   let objectDataDef = this.getIDataDefinition(objectItem);
        //   if(objectDataDef){
        //     arrayPropertySet.push(objectDataDef);
        //     return; // Just one definition.
        //   }
        // });
        typeDef['propertySet'] = objectDataDef;
      }
      return typeDef;
      
    }else if(this.isFunction(value)){
      return null;
    }else if(this.isObject(value)){
      let typeDef = this.getTypeDefinition(propName, this.getDataDefinitionType(value));
      let objectDataDef = this.getIDataDefinition(value, propertyNamesToIgnore);
      typeDef['propertySet'] =  objectDataDef;
      return typeDef;
    }else if(this.isBoolean(value)){
      return this.getTypeDefinition(propName, this.getDataDefinitionType(value));
    }else if(this.isDate(value)){
      return this.getTypeDefinition(propName, this.getDataDefinitionType(value));
    }else if(this.isSymbol(value)){
      return null;//no support for symbols yet
    }else if(this.isNull(value)){
      return null;
    }else if(this.isUndefined(value)){
      return null;
    }
    return null;
  }

  private getDataDefinitionType(value:any): string | null{
    if(this.isString(value)){
      return this.stringType;
    }else if(this.isNumber(value)){
      if (this.isInt(value))       {
        return this.integerType;
      }
      return this.doubleType;
    }else if(this.isArray(value)){
      return this.arrayType;      
    }else if(this.isFunction(value)){
      return null;
    }else if(this.isBoolean(value)){
      return this.booleanType;
    }else if(this.isDate(value)){
      return this.dateType;
    }else if(this.isSymbol(value)){
      return null;//no support for symbols yet
    }else if(this.isNull(value)){
      return null;
    }else if(this.isUndefined(value)){
      return null;
    }else if(this.isObject(value)){
      return this.propertySetType;
    }
    return null;
  }
  private getTypeDefinition(propName:string, type: string | null) : IDataDefinition{
    if(propName.indexOf('width') > -1 || propName.indexOf('height') > -1 || propName === 'dw' || propName === 'dh' || propName === 'dl'){
      return {      
        type: type,
        readOnly: true,
        columnDef: propName,
        header: propName,
        unit: 'length'
      };
    }
    
    return {      
      type: type,
      readOnly: true,
      columnDef: propName,
      header: propName
    };
  }
  // Returns if a value is a string
  private isString (value) {
    return typeof value === 'string' || value instanceof String;
  }
  // Returns if a value is really a number
  private isNumber (value) {
    return typeof value === 'number' && isFinite(value);
  }

  private isInt (value) {
    return value % 1 === 0;
  }

  // Returns if a value is an array
  private isArray (value) {
    return Array.isArray(value);
  }

  // Returns if a value is a function
  private isFunction (value) {
    return typeof value === 'function';
  }

  // Returns if a value is an object
  private isObject (value) {
    //return value && typeof value === 'object' && value.constructor === Object;
    //return value !== null && typeof value === 'object';
    return !Array.isArray(value) && value === Object(value);
  }

  // Returns if a value is null
  private isNull (value) {
    return value === null;
  }

  // Returns if a value is undefined
  private isUndefined (value) {
    return typeof value === 'undefined';
  }

  // Returns if a value is a boolean
  private isBoolean (value) {
    return typeof value === 'boolean';
  }

  // Returns if value is a date object
  private isDate (value) {
    return value instanceof Date;
  }

  // Returns if a Symbol
  private isSymbol (value) {
  return typeof value === 'symbol';
  }

  // Returns if value is an error object
  private isError (value) {
    return value instanceof Error && typeof value.message !== 'undefined';
  }

  // Returns if a value is a regexp
  private isRegExp (value) {
    return value && typeof value === 'object' && value.constructor === RegExp;
  }
  
}
